<template>
  <div>
    <div class="orgs">
      <span>{{ title }}</span>
    </div>
    <!-- <div class="site-lists">
        <div v-for="(data,i) in datas" :key="i" class="site-item flex justify-between items-center">
          <div class="flex items-center">
            <feather-icon
                icon="MapPinIcon"
                class="m-0 p-3"
              />
            {{data.name}}
          </div>
          <div class="flex items-center">
            <div class="box-info inout flex items-center justify-between">
              <div class="flex items-center text-blue">
                <feather-icon
                  icon="ArrowUpIcon"
                  class="m-0"
                />
                {{data.countIn != null ? data.countIn : 0}}
              </div>
              <div class="flex items-center text-red">
                <feather-icon
                  icon="ArrowDownIcon"
                  class="m-0"
                />
                {{data.countOut != null ? data.countOut : 0}}
              </div>
              <div class="flex items-center text-green">
                <feather-icon
                  icon="PlusIcon"
                  class="m-0"
                />
                {{data.countTotal != null ? data.countTotal : 0}}
              </div>
            </div>
            <div class="box-info cam flex items-center justify-between mr-3">
              <feather-icon
                  icon="BookmarkIcon"
                  class="m-0"
                />
                {{data.countBookmark != null ? data.countBookmark : 0}}
            </div>
            <vs-tooltip text="Detail">
              <a href="" v-if="next != ''" @click.prevent="goToNextStep(data)">
                <feather-icon
                  icon="ChevronRightIcon"
                  class="m-0"
                />
              </a>
            </vs-tooltip>
          </div>
        </div>
      </div> -->

    <vs-table stripe :data="datas">
      <template slot="thead">
        <vs-th style="width:50px">No</vs-th>
        <vs-th class="text-left">{{ title }}</vs-th>
        <vs-th v-if="occupancy" class="text-center text-blue" style="width:100px"><feather-icon icon="ArrowUpIcon"
            class="m-0" /> Entries</vs-th>
        <vs-th v-if="occupancy" class="text-center text-red" style="width:100px"><feather-icon icon="ArrowDownIcon"
            class="m-0" /> Exits</vs-th>
        <vs-th v-if="occupancy" class="text-center text-green" style="width:200px"><feather-icon icon="PlusIcon"
            class="m-0" /> Current Occupancy</vs-th>
        <vs-th v-if="occupancy" class="text-center" style="width:100px"><feather-icon icon="BookmarkIcon" class="m-0" />
          Bookmarks</vs-th>
        <vs-th class="text-center" style="width:50px">&nbsp;</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="(data, i) in datas" :key="i">
          <vs-td :data="i">
            {{ i + 1 }}
          </vs-td>

          <vs-td :data="data.name">
            {{ data.name }}
          </vs-td>

          <vs-td v-if="occupancy" class="text-center" :data="data.countIn">
            {{ data.countIn != null ? data.countIn : 0 }}
          </vs-td>

          <vs-td v-if="occupancy" class="text-center" :data="data.countOut">
            {{ data.countOut != null ? data.countOut : 0 }}
          </vs-td>

          <vs-td v-if="occupancy" class="text-center" :data="data.countTotal">
            {{ data.countTotal != null ? data.countTotal : 0 }}
          </vs-td>

          <vs-td v-if="occupancy" class="text-center" :data="data.countBookmark">
            {{ data.countBookmark != null ? data.countBookmark : 0 }}
          </vs-td>

          <vs-td class="text-center">
            <vs-tooltip text="Detail">
              <a href="" v-if="next != ''" @click.prevent="goToNextStep(data)">
                <feather-icon icon="ChevronRightIcon" class="m-0" />
              </a>
            </vs-tooltip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  //props: ['title', 'datas', 'next', 'occupancy'],
  props: {
    title: {
      type: String,
      required: true
    },
    datas: {
      type: Array,
      required: true,
    },
    next: {
      type: String,
      required: false
    },
    occupancy: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      breadcrumb: {
        home: {
          title: "Reports",
          link: "/reports",
          active: true,
        },
        site: {
          title: "Reports",
          link: "/reports",
          active: false,
        },
        area: {
          title: "Reports",
          link: "/reports",
          active: false,
        },
        camera: {
          title: "Reports",
          link: "/reports",
          active: false,
        }
      }
    }
  },
  methods: {
    goToNextStep(data) {
      const oldBC = localStorage.getItem('reportBreadcrumb')
      let oldBCObj = this.breadcrumb
      if (oldBC != undefined && oldBC != null) {
        oldBCObj = JSON.parse(oldBC)
      }

      oldBCObj.home.active = false;
      oldBCObj.site.active = false;
      oldBCObj.area.active = false;
      oldBCObj.camera.active = false;

      if (this.next.includes("site")) {
        oldBCObj.site = {
          title: data.name,
          link: "/reports/site/" + data.id,
          active: true
        }
      }

      if (this.next.includes("area")) {
        oldBCObj.area = {
          title: data.name,
          link: "/reports/area/" + data.id,
          active: true
        }
      }

      if (this.next.includes("camera")) {
        oldBCObj.camera = {
          title: data.name,
          link: "/reports/camera/" + data.id,
          active: true
        }
      }

      localStorage.setItem('reportBreadcrumb', JSON.stringify(oldBCObj))

      this.$router.push(this.next + '/' + data.id)
    }
  },
  mounted() {
    if (this.$route.name == 'reports_index') {
      console.log("masuk home")
      localStorage.setItem('reportBreadcrumb', JSON.stringify(this.breadcrumb))
    }
  }
}
</script>

<style lang="scss" scoped>
.orgs {
  font-size: 32px;

  span {
    color: #1372ac;
    font-weight: 600;
  }

  padding-bottom: 20px;
}

.site-lists {
  .site-item {
    font-weight: 600;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 20px;

    .box-info {
      border: 1px solid #ccc;
      background-color: #eee;
      padding: 5px 10px;
      height: 30px;

      &.inout {
        width: 250px;
        margin-right: 10px;
      }

      &.cam {
        width: 100px;
      }
    }
  }
}
</style>